import {Injectable} from "@angular/core";
import { filter, fromEvent, map, Observable, share, Subject, take, tap } from 'rxjs';
import {AppService} from "../app.service";

import {ITabitWrapperMessage, ITabitWrapperConfig} from 'src/types/globals'

@Injectable({
	providedIn: 'root'
})
export class InAppService {
	private _consumer$: Subject<ITabitWrapperMessage> = new Subject<ITabitWrapperMessage>();
	config: ITabitWrapperConfig;
	messages: any[] = []

	constructor(
		private appService: AppService,
	) {
		window.wrapperConsumer = this.onWrapperMessage.bind(this);
		this.config = this.getConfig()
		if (window.flutter_inappwebview) this.handleConsumerReadyAction();
	}

	onWrapperMessage(message: ITabitWrapperMessage): void {
		this.messages.unshift(message);
		this._consumer$.next(message);
	}
	dispatchWrapperAction(action: TabitWrapperAction, silent?): void {
		if (!window.flutter_inappwebview && !silent) {
			this.appService.toastrSimple('window?.flutter_inappwebview is undefined', action);
			return;
		}
		window.flutter_inappwebview.callHandler(action);
	}

	handleConsumerReadyAction(): void {
		this.dispatchWrapperAction(TabitWrapperAction.CONSUMER_READY, true);
	}

	openQrScanner(): Observable<TabitWrapperMessageResult> {
		this.dispatchWrapperAction(TabitWrapperAction.OPEN_QR_SCANNER);
		return this._consumer$.pipe(
			filter((message: TabitWrapperMessage) => message.type === TabitWrapperMessageType.QR_SCANNER),
			map((message: TabitWrapperMessage) => message.data),
			take(1)
		);
	}

	// -------------------------------------------------------------------->

	getConfig(): ITabitWrapperConfig {
		const config: ITabitWrapperConfig = window.wrapperConfig;
		if (config) return config;

		const url: URL = (() => {
			let url: URL = new URL(window.location.href);
			//if (url.hash) url = new URL(`${url.host}/${url.hash.substring(1)}`);
			return url;
		})();

		const getIsWrapper = (url: URL): boolean => {
			const getIsWrapperFromUrl = (): boolean | null => {
				const wrapperQueryString: string | null = url.searchParams.get('wrapper');
				if (wrapperQueryString == null) return null;
				const isWrapperAsNum: number = +wrapperQueryString;
				return !!isWrapperAsNum;
			};
			const isWrapperFromUrl: boolean | null = getIsWrapperFromUrl();
			if (isWrapperFromUrl != null) return isWrapperFromUrl;
			return sessionStorage.getItem('wrapper') != null;
		};

		const isWrapper: boolean = getIsWrapper(url);

		return {
			isWrapper,
			provider: '',
			messagingToken: '',
			version: {
				currentVersion: '',
				storeVersion: '',
			},
			device: {
				id: '',
				model: '',
				manufacturer: '',
				os: '',
				osVersion: '',
			},
			redirectEnvs: {

			},
		};
	};

}

export enum TabitWrapperMessageType {
	APP_RESUMED = 'appResumed',
	PERMISSIONS = 'permissions',
	GEO_LOCATION = 'geoLocation',
	NOTIFICATIONS = 'notifications',
	CAMERA = 'camera',
	GALLERY = 'gallery',
	QR_SCANNER = 'qrScanner',
	DEEP_LINK = 'deepLink',
}

export enum TabitWrapperAction {
	CONSUMER_READY = 'consumerReady',
	CHANGE_ENV = 'changeEnv',
	PERMISSIONS = 'permissions',
	OPEN_APP_SETTINGS = 'openAppSettings',
	STORAGE = 'storage',
	GEO_LOCATION = 'geoLocation',
	CAMERA = 'camera',
	GALLERY = 'gallery',
	OPEN_QR_SCANNER = 'openQrScanner',
	OPEN_URL = 'openUrl',
	SPLASH = 'splash',
}

export enum TabitWrapperPermissionStatus {
	AUTHORIZED = 'authorized',
	DENIED = 'denied',
	NOT_DETERMINED = 'notDetermined',
	PROVISIONAL = 'provisional',
}

export interface TabitWrapperMessageResult<T = any> {
	status: TabitWrapperPermissionStatus;
	data: T;
}
export interface TabitWrapperMessage<T = any> {
	type: TabitWrapperMessageType;
	data: T;
}

